import React from 'react';
import { PlanoForm } from './PlanoForm';

export const NovoPlano: React.FC = () => {
  return <PlanoForm />;
}; 